import { Experiments } from "./experimentsList";
import {
  selectIsExperimentVariant,
  type ExperimentsState,
} from "./selectExperimentVariant";

export const selectShowAllAirCanadaPorterFares = (
  state: ExperimentsState
): boolean =>
  selectIsExperimentVariant(
    state,
    Experiments.AIRCANADA_PORTER_SHOW_ALL_GRID_FARES.name,
    Experiments.AIRCANADA_PORTER_SHOW_ALL_GRID_FARES.variants.available
  );
